'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _static = require('inline-style-prefixer/static');

var _static2 = _interopRequireDefault(_static);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return function (style) {
    return (0, _static2.default)(style);
  };
}; /*  weak */


module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/plugins/prefixer.js
// module id = 451
// module chunks = 0